import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminLayoutComponent } from "./components/theme/admin-layout/admin-layout.component";
import { AdminLoginComponent } from "./components/account/admin-login/admin-login.component";
import { UserListComponent } from "./components/user-management/user-list/user-list.component";
import { EmailActivationComponent } from "./components/account/email-activation/email-activation.component";
import { ChangePasswordComponent } from "./components/account/change-password/change-password.component";
import { ForgotPasswordComponent } from "./components/account/forgot-password/forgot-password.component";
import { ForceChangePasswordService } from "../shared/providers/guard/ForceChangePassword/force-change-password.service";
import { FranchisesAdminListComponent } from "./components/franchise/franchise-admin-list/franchise-admin-list.component";
import { FranchiseAdminDetailsComponent } from "./components/franchise/franchise-admin-details/franchise-admin-details.component";
import { ReasonListComponent } from "./components/reasons/reason-list/reason-list.component";
import { TwoFactorAuthComponent } from "./components/account/two-factor-auth/two-factor-auth.component";
import { DonorRequestAdminListComponent } from "./components/request/donor-request-admin-list/donor-request-admin-list.component";

const routes: Routes = [
  {
    path: "email-activation",
    component: EmailActivationComponent,
    data: { hasHeader: false, hasFooter: false },
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    data: { hasHeader: false, hasFooter: false },
  },
  {
    path: "reset-password",
    component: ChangePasswordComponent,
    data: { hasHeader: false, hasFooter: false },
  },
  {
    path: "adminlogin",
    component: AdminLoginComponent,
    data: { hasHeader: false, hasFooter: false },
  },
  {
    path: "adminlogin/twofactor-auth",
    component: TwoFactorAuthComponent,
    data: { hasHeader: false, hasFooter: false },
  },
  {
    path: "admin",
    component: AdminLayoutComponent,
    data: { hasHeader: false, hasFooter: false },
    children: [
      {
        path: "InternalFranchises",
        component: FranchisesAdminListComponent,
        data: { isInternal: true },
        canActivate: [ForceChangePasswordService],
      },
      {
        path: "ExternalFranchises",
        component: FranchisesAdminListComponent,
        data: { isInternal: false },
        canActivate: [ForceChangePasswordService],
      },
      {
        path: "DonorRequest",
        component: DonorRequestAdminListComponent,
        canActivate: [ForceChangePasswordService],
      },
      {
        path: "Franchise/:id",
        component: FranchiseAdminDetailsComponent,
        data: { internal: false },
        canActivate: [ForceChangePasswordService],
      },
      {
        path: "User",
        component: UserListComponent,
        canActivate: [ForceChangePasswordService],
      },
      {
        path: "Reasons",
        component: ReasonListComponent,
        canActivate: [ForceChangePasswordService],
      },
      { path: "", redirectTo: "/adminlogin", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
